import requesta from '@/base/service'
const baseURL = process.env.VUE_APP_BASE_API_AI
const request = (data) => {
  return requesta({ ...data, ...{ baseURL } })
}
//  查询总权益次数
export function getTotalTimes(data) {
  return request({
    url: 'clue/getTotalTimes',
    method: 'post',
    data
  })
}

//  查询已使用次数
export function getUsedTimes(data) {
  return request({
    url: 'clue/getUsedTimes',
    method: 'post',
    data
  })
}

//  查询用户名字
export function getLoginName(data) {
  return request({
    url: 'clue/getLoginName',
    method: 'get',
    params: data
  })
}

//  新版查询总权益次数
export function newGetTotalTimes(data) {
  return request({
    url: 'clue/newGetTotalTimes',
    method: 'post',
    data
  })
}




